import dense from "./dense";
import none from "./none";

// The first property here is the default reporter
const reporters = {dense, none};

export default reporters;
